import { i18n, i18nPlurals } from "../../domain/i18n.js";

export default {
  [i18nPlurals.brands["0"]]: 'marques',
  [i18nPlurals.brands["1"]]: 'marque',
  [i18nPlurals.brands["2"]]: 'marques',

  [i18n.generic.authorizedBy]: 'authorized.by',
  [i18n.generic.brands]: '{count} [brands]',

  [i18n.alt.authorizedBySeal]: '(authorized.by)',
  [i18n.alt.tuvSeal]: '(TÜV Saarland ShopIdent)',

  [i18n.menu.checkAuthorizations.caption]: 'Valider les autorisations',
  [i18n.menu.imprint.caption]: 'Mentions légales',
  [i18n.menu.imprint.link]: 'https://www.authorized.by/en/imprint/',
  [i18n.menu.privacyPolicy.caption]: 'Politique de confidentialité',
  [i18n.menu.privacyPolicy.link]: 'https://www.authorized.by/en/privacy-policy/',

  [i18n.header.texts.full.isAuthorized1]: '{url}',
  [i18n.header.texts.full.isAuthorized2]: 'est un partenaire en ligne autorisé',
  [i18n.header.texts.full.isAuthorized2_t0NotApproved]: 'Ce site est nouveau sur <a href="https://www.authorized.by/" target="_blank">authorized.by</a> et en attente d\'approbation pour être autorisé par les marques',
  [i18n.header.texts.full.isAuthorized2_t0NoBrands]: 'Ce site est nouveau sur <a href="https://www.authorized.by/" target="_blank">authorized.by</a> et en attente d\'autorisations de Brands',
  [i18n.header.texts.full.isAuthorized3]: 'de ces {brands}',
  [i18n.header.texts.full.brands]: '{count} [brands]:',
  [i18n.header.texts.brandLink.multiple]: '{brandName} + {count} autres marques',
  [i18n.header.texts.brandLink.two]: '{brandName} + 1 autre marque',
  [i18n.header.texts.brandLink.one]: '{brandName}',

  [i18n.contents.texts.lastVerified]: 'Dernière autorisation',
  [i18n.contents.texts.lastVerified_t0NotApproved]: '<a href="https://app.authorized.by/" target="_blank">>Awaiting Approval</a>',
  [i18n.contents.texts.lastVerified_t0NoBrands]: '<a href="https://app.authorized.by/" target="_blank">>Awaiting Authorization</a>',
  [i18n.contents.texts.tuvMember]: 'authorized.by | TÜV Saarland Group',
  [i18n.contents.texts.t0Message]: "Revenez bientôt pour les marques autorisées!",

  [i18n.contents.texts.originalityConfirmedTitle]: "Originalité confirmée",
  [i18n.contents.texts.originalityConfirmedText]: "{url} garantit expressément l'originalité de ce produit.",
  [i18n.contents.texts.authRetailerTitle]: "Revendeur agréé",
  [i18n.contents.texts.authRetailerText]: "{url} est spécialement autorisée par la marque {brand} à vendre ce produit en ligne et est un partenaire de confiance de la marque.",
  [i18n.contents.texts.shopCheckTitle]: 'Identité vérifiée',
  [i18n.contents.texts.shopCheckText]: 'Les détails de l´entreprise sur l´identité du fournisseur de la boutique {url} ont été vérifiés pour la dernière fois le {date} dans le cadre de la procédure TÜV Saarland ShopIdent.',

  [i18n.contents.texts.shopCheckTitle_brandSponsored]: 'Achats en toute sécurité',
  [i18n.contents.texts.shopCheckText_brandSponsored]: '{url} répond aux exigences spécifiques de {brand} et est un partenaire de confiance de la marque.',

  [i18n.contents.texts.originalityConfirmedTitle_d2c]: "La boutique officielle de la marque",
  [i18n.contents.texts.originalityConfirmedText_d2c]: "{url} est la boutique officielle de la marque et est exploitée au nom de {brand}.",
  [i18n.contents.texts.authRetailerTitle_d2c]: "Directement du fabricant",
  [i18n.contents.texts.authRetailerText_d2c]: "{url} propose des produits de marque directement du fabricant {brand}.",
  [i18n.contents.texts.shopCheckTitle_d2c]: 'Identité vérifiée',
  [i18n.contents.texts.shopCheckText_d2c]: 'Les détails de l\'entreprise sur l\'identité du fournisseur de la boutique {url} ont été vérifiés pour la dernière fois dans le cadre de la procédure TÜV Saarland ShopIdent le {date}.',
  [i18n.contents.texts.shopCheckTitle_noTuv_d2c]: 'Achats en toute sécurité',
  [i18n.contents.texts.shopCheckText_noTuv_d2c]: '{url} répond aux exigences spécifiques de {brand} et est la boutique officielle de la marque.',

  [i18n.footer.showCertificate]: 'VOIR LE CERTIFICAT',
};
